module.exports = __webpack_public_path__ + "static/media/gi.e718f550.png";